<script>
    let {
        scale,
        value = $bindable(),
        disabled = false,
        readonly = false,
        showWeights = false,
        isDescending,
    } = $props()

    const inputGroup = $props.id()
</script>

<section inert={readonly}>
    {#each scale as item, index (`${item.key}__${isDescending}`)}
        <label title={item.label}>
            <input
                type="radio"
                name={inputGroup}
                value={item.key}
                bind:group={value}
                {disabled}
            />
            <div class="dot"><div></div></div>
            <div class="text">
                {item.label}
                {#if showWeights}
                    <div class="item-weight">
                        {const itemWeight = isDescending ? scale.length - index : index + 1}
                        {window.i18n.sprintf(window.i18n.ngettext('%s point', '%s points', itemWeight), itemWeight)}
                    </div>
                {/if}
            </div>
        </label>
    {/each}
</section>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
section {
  display: grid;
  grid-auto-columns: 1fr;
  gap: 8px;
}

label {
  position: relative;
  cursor: pointer;
  grid-row: 1;
  font-size: 14px;
  border-radius: 12px;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  transition: background 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
label :global(svg) {
  width: 16px;
  height: 16px;
  transition: fill 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
  flex-shrink: 0;
}
label {
  background-color: #fff;
  color: #122d40;
  border: solid 1px hsl(40, 4%, 84%);
}
label :global(svg) {
  fill: #122d40;
}
label > :global(*) {
  display: inline-flex;
}
label > :global(*:empty) {
  display: none;
}
label {
  flex-direction: column;
  text-align: center;
  padding: 12px 4px;
}
label > *:empty {
  display: unset;
}
label:hover:not(:has(input:disabled)) {
  background-color: hsl(40, 20%, 96%);
}
label:has(input:checked) {
  color: hsl(205, 60%, 44%);
  background-color: rgba(17.6%, 48.4%, 70.4%, 0.1);
  border-color: rgba(17.6%, 48.4%, 70.4%, 0.8);
}
label input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
label input:disabled ~ * {
  cursor: not-allowed;
}
label input:checked ~ .dot {
  background-color: hsl(205, 60%, 44%);
  border-color: hsl(205, 60%, 44%);
}
label input:checked ~ .dot > div {
  background-color: #fff;
}
label input:focus ~ .dot {
  box-shadow: 0 0 10px 0 rgba(17.6%, 48.4%, 70.4%, 0.5);
}
label .dot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid #9a9bb5;
  border-radius: 50%;
}
label .dot > div {
  width: 10px;
  height: 10px;
  border-radius: inherit;
}
label .text {
  flex-direction: inherit;
}
label .item-weight {
  color: #9a9bb5;
}</style>
